'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { Button, DeclarativeForm, FlexContainer, Label } from '@bridge/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@icons/classic/regular';
import { getSSOFormConfig } from '../_formConfigs/loginFormConfigs';
import type { ReactElement } from 'react';
import type { LoginEmailFormValues } from '../_schemas/loginFormSchemas';
interface SSOLoginFormProps {
  isGeneratingLink: boolean;
  onSubmit: (values: LoginEmailFormValues) => Promise<void>;
  onBackClick: () => void;
  onValidationError?: () => void;
}
const SSOLoginForm = t0 => {
  const $ = _c(17);
  const {
    isGeneratingLink,
    onSubmit,
    onBackClick,
    onValidationError
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getSSOFormConfig();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const formConfig = t1;
  let t2;
  if ($[1] !== onValidationError) {
    t2 = () => {
      onValidationError?.();
    };
    $[1] = onValidationError;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleError = t2;
  let t3;
  if ($[3] !== isGeneratingLink) {
    t3 = () => <Button className="h-12 w-full" pending={isGeneratingLink} size="lg" type="submit" variant="primary">Continue</Button>;
    $[3] = isGeneratingLink;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const actionsComponent = t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <FontAwesomeIcon icon={faChevronLeft} />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== onBackClick) {
    t5 = <div className="mb-6 flex justify-start absolute top-4 left-4"><Button onClick={onBackClick} size="sm" variant="quaternary">{t4}Back</Button></div>;
    $[6] = onBackClick;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Label className="text-content-secondary whitespace-nowrap" size="sm">This is only available for organizations with SSO enabled.</Label>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      form: "space-y-2"
    };
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== actionsComponent || $[11] !== handleError || $[12] !== onSubmit) {
    t8 = <FlexContainer className="flex flex-col gap-2">{t6}<DeclarativeForm classNames={t7} actionsComponent={actionsComponent} config={formConfig} onError={handleError} onSubmit={onSubmit} showSeparator={false} /></FlexContainer>;
    $[10] = actionsComponent;
    $[11] = handleError;
    $[12] = onSubmit;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t5 || $[15] !== t8) {
    t9 = <>{t5}{t8}</>;
    $[14] = t5;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
};
export default SSOLoginForm;